import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { history } from '../../../_services/essentials/helpers';
import { userActions, alertActions, breadcrumbsActions } from '../../../_services/essentials/store';
import Typography from "@mui/material/Typography";
import { Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
//import FormLabel from "@mui/material/FormLabel";
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';

import { TextField, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
const Card = styled(MuiCard)(({ theme }) => ({
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    margin: 'auto',
    borderRadius: '8px', // Rounded corners
    background: 'var(--Neutral-White, #FFF)', // Background color
    boxShadow: '0px 12px 26px 0px rgba(16, 30, 115, 0.06)', // Floating shadow
    [theme.breakpoints.up('sm')]: {
        width: '35%',
    },
}));
export { ChangePassword };

function ChangePassword() {
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState({
        oldPassword: false,
        newPassword: false,
        confirmPassword: false,
    });


    const handleTogglePassword = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };
    const loggedInUser = useSelector(x => x.auth?.loggedInUser);
    const id = loggedInUser?.id;

    // form validation rules
    const validationSchema = Yup.object().shape({
        password: Yup.string().trim()
            .required('Required*'),
        newPassword: Yup.string().trim().required("New password is required")
            .min(6, 'Password must be at least 6 characters'),
        confirmNewPassword: Yup.string().trim().required("Confirm New password is required")
            .oneOf([Yup.ref('newPassword')], 'Password and Confirm Password must match')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    //    const { register, handleSubmit, reset, formState } = useForm(formOptions);
    const { register, handleSubmit, formState } = useForm(formOptions);
    //    const { errors, isSubmitting } = formState;
    const { errors } = formState;

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(`Change Password`));
    }, []);

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            // create or update user based on id param
            let message;
            if (id) {
                message = await dispatch(userActions.changePassword({ id, data })).unwrap();
                console.log(message);
                dispatch(alertActions.success({ message, showAfterRedirect: true }));
                history.navigate(-1);
            }
            // redirect to user list with success message

        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <Card sx={{
            ml: 2
        }}>
            <Stack
                sx={{
                    justifyContent: 'space-between', flexGrow: '1', gap: 1
                }}
            >
                {/* <Typography component="h2" variant="h6" sx={{mb: 2}}>
                Change Password
            </Typography> */}
                {/*<Typography*/}
                {/*    component="h1"*/}
                {/*    variant="h4"*/}
                {/*    sx={{ width: '100%', fontSize: '16px' }}*/}
                {/*>*/}
                {/*    Enter the email address associated with your account and we'll send you a link to reset your password.*/}
                {/*</Typography>*/}
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        // gap: 2
                    }}
                    >

                        <Stack direction={"column"}
                            sx={{
                                justifyContent: 'space-between',
                            }}
                        >
                            <Stack direction={"column"}
                                sx={{
                                    justifyContent: 'space-between',
                                    // p: 2
                                }}
                            >

                                <FormControl>
                                    {/* <FormLabel htmlFor="password">Current Password</FormLabel> */}
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Current Password<span style={{ color: 'red' }}>*</span></Typography>

                                    <TextField
                                        name="password"
                                        placeholder=""
                                        // type="password"
                                        type={showPassword.oldPassword ? 'text' : 'password'}
                                        id="password"
                                        autoComplete="off"
                                        autoFocus
                                        fullWidth
                                        variant="outlined"
                                        {...register('password', { required: true })}
                                        error={Boolean(errors.password)}
                                        helperText={errors.password ? errors.password.message : ""}
                                        sx={{ mb: 2 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            height: '24px'
                                                        }}
                                                        onClick={() => handleTogglePassword('oldPassword')}
                                                    >
                                                        {showPassword.oldPassword ? <Visibility /> : <VisibilityOff />}
                                                    </div>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                                <FormControl>
                                    {/* <FormLabel htmlFor="newPassword">New Password</FormLabel> */}
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>New Password<span style={{ color: 'red' }}>*</span></Typography>

                                    <TextField
                                        name="newPassword"
                                        placeholder=""
                                        // type="password"
                                        type={showPassword.newPassword ? 'text' : 'password'}

                                        id="newPassword"
                                        autoComplete="off"
                                        fullWidth
                                        variant="outlined"
                                        {...register('newPassword', { required: true })}
                                        error={Boolean(errors.newPassword)}
                                        helperText={errors.newPassword ? errors.newPassword.message : ""}
                                        sx={{ mb: 2 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            height: '24px'
                                                        }}
                                                        onClick={() => handleTogglePassword('newPassword')}
                                                    >
                                                        {showPassword.newPassword ? <Visibility /> : <VisibilityOff />}

                                                    </div>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                                <FormControl>
                                    {/* <FormLabel htmlFor="confrimNewPassword">Confirm New Password</FormLabel> */}
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Confirm New Password<span style={{ color: 'red' }}>*</span></Typography>

                                    <TextField
                                        name="confirmNewPassword"
                                        placeholder=""
                                        // type="password"
                                        type={showPassword.confirmPassword ? 'text' : 'password'}

                                        id="confirmNewPassword"
                                        autoComplete="off"
                                        fullWidth
                                        variant="outlined"
                                        {...register('confirmNewPassword', { required: true })}
                                        error={Boolean(errors.confirmNewPassword)}
                                        helperText={errors.confirmNewPassword ? errors.confirmNewPassword.message : ""}
                                        sx={{ mb: 2 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            height: '24px'
                                                        }}
                                                        onClick={() => handleTogglePassword('confirmPassword')}
                                                    >
                                                        {showPassword.confirmPassword ? <Visibility /> : <VisibilityOff />}

                                                    </div>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>

                                {/*<FormControlLabel*/}
                                {/*    control={<Checkbox value="remember" color="primary" />}*/}
                                {/*    label="Remember me"*/}
                                {/*/>*/}
                                {/*<ForgotPassword open={open} handleClose={handleClose} />*/}
                            </Stack>
                            <Stack direction={"row"}
                                sx={{
                                    // justifyContent: 'center',
                                    ml: '10%',
                                    gap: 2
                                    // p: 2
                                }}
                            >
                                <Button
                                    type="submit"
                                    variant="contained"
                                >
                                    Set Password
                                </Button>
                                {/* <Button onClick={() => history.navigate("/account/login")} variant="outlined"
                                    color="primary" size="small">
                                    Cancel
                                </Button> */}
                                <Button onClick={() => history.navigate("/account/login")} variant="outlined"
                                    size="small" sx={{ backgroundColor: 'buttonVar.cancel', fontSize: 16, fontWeight: 600 }}  >
                                    Cancel
                                </Button>

                            </Stack>
                        </Stack>
                    </Box>
                </form>
            </Stack>
        </Card>
    );
}
